export default "__VITE_ASSET__DTO$Y_8O__"